import {StyleSheet} from 'react-native';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: hasError => ({
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: hasError ? 2 : 1,
      borderRadius: 16,
      borderColor: hasError ? colors.danger : colors.borderMuted,
      paddingHorizontal: 12,
    }),
    inputContainer: hasError => ({
      flex: 1,
      fontSize: 16,
      fontFamily: FONTS.regularFont,
      color: colors.textPrimary,
      paddingVertical: 16,
    }),
    inputTitleStyle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 16,
      lineHeight: 24,
      color: colors.textMuted,
      marginBottom: 8,
    },
    errorText: {
      color: colors.danger,
      fontFamily: FONTS.regularFont,
      fontSize: 14,
      lineHeight: 21,
      marginTop: 8,
    },
    rightImage: {
      width: 10,
      height: 10,
      resizeMode: 'contain',
      marginLeft: 16,
    },
    leftText: {
      letterSpacing: 0,
      fontSize: 16,
      fontFamily: FONTS.boldFont,
      color: colors.textPrimary,
      marginRight: 5,
    },
    rightText: {
      fontSize: 14,
      fontFamily: FONTS.regularFont,
      color: colors.textDisabled,
    },
  });

export default makeStyles;
